/**
 * Rota parçası indirilirken gösterilen iskelet.
 *
 * NEDEN SPINNER DEĞİL: Dönen bir çark, sayfanın nasıl görüneceği
 * hakkında hiçbir şey söylemez ve bekleme süresini uzun hissettirir.
 * İskelet, gelecek düzenin şeklini önden çizer — algılanan bekleme
 * süresi belirgin biçimde kısalır ve yükleme tamamlandığında içerik
 * sıçramaz (layout shift olmaz).
 *
 * Yapı, çoğu ekranın gerçek düzenini taklit eder: başlık + 4'lü KPI
 * sırası + geniş içerik kartı.
 */
export function PageSkeleton() {
  return (
    <div className="app-page" aria-busy="true" aria-live="polite">
      <span className="visually-hidden">Sayfa yükleniyor…</span>

      {/* Sayfa başlığı */}
      <div>
        <div className="skeleton mb-2" style={{ height: '1.5rem', width: '14rem' }} />
        <div className="skeleton" style={{ height: '0.85rem', width: '22rem' }} />
      </div>

      {/* KPI kartı sırası */}
      <div className="row">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="col-sm-6 col-xl-3">
            <div className="card">
              <div className="card-body">
                <div className="skeleton mb-2" style={{ height: '1.8rem', width: '7rem' }} />
                <div className="skeleton" style={{ height: '0.8rem', width: '5rem' }} />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* İçerik kartı */}
      <div className="card">
        <div className="card-body">
          <div className="skeleton mb-3" style={{ height: '1rem', width: '10rem' }} />
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="skeleton mb-2" style={{ height: '2.25rem' }} />
          ))}
        </div>
      </div>
    </div>
  );
}
